// Left navigation of the phone number panel (SettingsPhone-* mockups).

export type PhoneSettingsView = 'info' | 'hours' | 'rules';

export interface PhoneSettingsItem {
    id: string;
    label: string;
    view: PhoneSettingsView;
    /** Section inside the call rules to scroll to. */
    anchor?: string;
}

export interface PhoneSettingsSection {
    title: string;
    items: PhoneSettingsItem[];
}

export const PHONE_SETTINGS_SECTIONS: PhoneSettingsSection[] = [
    {
        title: 'General',
        items: [
            {id: 'info', label: 'Information', view: 'info'},
            {id: 'hours', label: 'Working hours', view: 'hours'},
        ],
    },
    {
        title: 'What happens when you work?',
        items: [
            {id: 'welcome', label: 'Welcome message', view: 'rules', anchor: 'welcomeMessageWorking'},
            {id: 'forward', label: 'Forward call', view: 'rules', anchor: 'forwardWorking'},
            {id: 'queue', label: 'Call queue', view: 'rules', anchor: 'callQueue'},
        ],
    },
    {
        title: 'After hours',
        items: [
            {id: 'afterHours', label: 'After hours message', view: 'rules', anchor: 'afterHoursMessage'},
            {id: 'voicemail', label: 'Voicemail', view: 'rules', anchor: 'voiceMail'},
        ],
    },
];

export const findPhoneSettingsItem = (id: string): PhoneSettingsItem =>
    PHONE_SETTINGS_SECTIONS.flatMap((s) => s.items).find((i) => i.id === id) ?? PHONE_SETTINGS_SECTIONS[0].items[0];
